module.exports = {
  object: require("./156.js"),
  array: require("./157.js"),
  regex: require("./158.js")
};